import { useContext } from 'react';

import {
    DossierApiObject,
    DossiersReducerType,
    JalLegalesApi,
} from '@europrocurement/l2d-domain/reducers';

import {
    CommandeApi,
    DossierApi,
    FactureVenteApi,
    JournalAnnoncesLegalesApi,
    RubriqueFacturationApi,
    TauxTvaApi,
} from '@europrocurement/l2d-domain/openApi/ApiDossiers';
import { DataSourcesThunksType, getDataThunkType } from '@europrocurement/l2d-redux-utils';
import L2DApiContext from '../L2DApiContext';

export const useDossierService = () => {
    const context = useContext(L2DApiContext);
    if (!context) {
        throw new Error('useL2DApi must be used within a L2DApiProvider');
    }

    if (!context.dossiers) {
        throw new Error('Achat service is not registred in L2DApiProvider');
    }

    const { apis, slices, thunks, fetchItems, getItems, reducer } = context.dossiers;

    return {
        // [DOSSIERS] Apis

        dossierApi: apis.dossierApi as DossierApi,
        tauxTvaApi: apis.tauxTvaApi as TauxTvaApi,
        commandeApi: apis.commandeApi as CommandeApi,
        factureVenteApi: apis.factureVenteApi as FactureVenteApi,
        journalAnnoncesLegalesApi: apis.journalAnnoncesLegalesApi as JournalAnnoncesLegalesApi,
        rubriqueFacturationApi: apis.rubriqueFacturationApi as RubriqueFacturationApi,

        // [DOSSIERS] Slices

        commandeSlice: slices.commandeSlice,
        dossierSlice: slices.dossierSlice,
        factureVenteSlice: slices.factureVenteSlice,
        journalSlice: slices.journalSlice,
        rubriqueFacturationSlice: slices.rubriqueFacturationSlice,
        tauxTvaSlice: slices.tauxTvaSlice,

        // [DOSSIERS] Thunks
        commandeDataSourcesThunks: thunks.commandeDataSourcesThunks,
        dossierDataSourcesThunks:
            thunks.dossierDataSourcesThunks as DataSourcesThunksType<DossierApiObject>,
        factureVenteDataSourcesThunks: thunks.factureVenteDataSourcesThunks,
        journalDataSourcesThunks: thunks.journalDataSourcesThunks,
        rubriqueFacturationDataSourcesThunks: thunks.rubriqueFacturationDataSourcesThunks,
        tauxTvaDataSourcesThunks: thunks.tauxTvaDataSourcesThunks,

        // [DOSSIERS] Actions - Fetch data
        getCommande: fetchItems.getCommande,
        getDossier: fetchItems.getDossier as getDataThunkType<DossierApiObject>,
        getAutocompleteDossier:
            fetchItems.getAutocompleteDossier as getDataThunkType<DossierApiObject>,
        getFactureVente: fetchItems.getFactureVente,
        getJournal: fetchItems.getJournal as getDataThunkType<JalLegalesApi>,
        getRubFac: fetchItems.getRubFac,
        getTauxTva: fetchItems.getTauxTva,

        // [DOSSIERS] Actions - select item
        selectCommande: getItems.selectCommande,
        selectDossier: getItems.selectDossier,
        selectAutocompleteDossier: getItems.selectAutocompleteDossier,
        selectFactureVente: getItems.selectFactureVente,
        selectJournal: getItems.selectJournal,
        selectRubFac: getItems.selectRubFac,
        selectTauxTva: getItems.selectTauxTva,

        // [DOSSIERS] Reducer
        reducer: reducer as DossiersReducerType,

        models: {},
    };
};
